"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var BackButton = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("button", { type: 'button', className: 'estimateForm-BackButton', onClick: store.onClick }, store.label));
});
exports.default = BackButton;
